import CookieBanner from '@components/CookieBanner/CookieBanner'
import CookiePreferencesModal from '@components/CookiePreferencesModal/CookiePreferencesModal'

const CookieConsentManager = () => {
  return (
    <>
      <CookieBanner />
      <CookiePreferencesModal />
    </>
  )
}

export default CookieConsentManager
